import clsx from 'clsx';
import { ComponentPropsWithoutRef, forwardRef } from 'react';

export type RegistryTableColgroupProps = ComponentPropsWithoutRef<'colgroup'>;

export const createRegistryTableColgroup = () => {
	const RegistryTableColgroup = forwardRef<HTMLTableColElement, RegistryTableColgroupProps>(
		({ className, ...props }, ref) => (
			<colgroup
				ref={ref}
				className={clsx('registry-table-colgroup', className)}
				{...props}
			/>
		),
	);

	return RegistryTableColgroup;
};
